/**
 *
 * ListFilters
 *
 */

import FormControl from '@material-ui/core/FormControl'
// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
import React from 'react'

// import { FormattedMessage } from 'react-intl';
// import messages from './messages';

// eslint-disable-next-line no-unused-vars
// biome-ignore lint/correctness/noUnusedVariables: TODO
const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width: 'auto',
    float: 'left',
  },
  inputstyle: {},
})

/* eslint-disable react/prefer-stateless-function */
class InputOne extends React.Component {
  render() {
    const { classes, ContainterStyle, ...rest } = this.props
    // const { filterData, selected } = this.state;
    return (
      <FormControl style={ContainterStyle} className={classes.root}>
        <input {...rest} className={classes.inputstyle} />
      </FormControl>
    )
  }
}

InputOne.defaultProps = {}
export default withStyles(styles)(InputOne)
